"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for SubMenuButton control
         */
        var SubMenuButton = /** @class */ (function (_super) {
            __extends(SubMenuButton, _super);
            function SubMenuButton(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                /**
                 * Checks after a timeout to see if the submenu button should close its flyout
                 */
                _this.CloseContextMenu = function () {
                    window.setTimeout(function () {
                        if (_this.subMenuFlyout && $dyn.context(_this.subMenuFlyout[0])) {
                            var flyoutDataContext = $dyn.context(_this.subMenuFlyout[0]);
                            if (!_this.isHovered() && flyoutDataContext.shouldClose()) {
                                _this.showMenu(false);
                            }
                        }
                    }, 250);
                };
                _this.Click = function (e) {
                    _this.subFlyoutShowChanged(!_this.showMenu());
                    e.stopPropagation();
                    $dyn.log.stopPropagation && $dyn.log.stopPropagation("Context menu -> submenu -> click stopPropagation");
                };
                /**
                 * when the hovered state changes calls subFlyoutShowChanged
                 * @param value the hovered state.
                 */
                _this.hoveredChanged = function (value) {
                    _this.subFlyoutShowChanged(value);
                };
                /**
                 * when the showMenu state changes manage the focus and close as needed
                 * @param value the showMenu state.
                 */
                _this.showMenuChanged = function (value) {
                    if (!$dyn.value(value) && _this._parent) {
                        // if another menu was opend before the timeout fired to close this dont take focus
                        if (!_this._parent.hasOpenSubmenu()) {
                            // if the sub menu buttons menu closed set focus back to the button
                            _this.element.focus();
                        }
                        // allow it to try to close
                        _this._parent.tryClose();
                    }
                };
                if (data && data.DataSource) {
                    _this.Label = $dyn.label(data.DataSource.Label);
                    _this.contextMenuOptions = data.DataSource.contextMenuOptions;
                }
                _this.Visible = true;
                _this.Enabled = true;
                _this.isHovered = $dyn.observable(false);
                _this.showMenu = $dyn.observable(false);
                _this.subMenuFlyout = null;
                _this.options = null;
                $dyn.observe(_this.isHovered, _this.hoveredChanged);
                // do not observe the change on create
                _this.showMenu.valueChanged.subscribe(_this.showMenuChanged);
                return _this;
            }
            /**
             * Checks if the submenu is open
             * @returns True if the submenu is open.
             */
            SubMenuButton.prototype.isSubContextMenuOpen = function () {
                return this.showMenu();
            };
            /**
             * when the state changes (Click and hoveredChanged) open or close the flyout
             * @param value the flyout state requested.
             */
            SubMenuButton.prototype.subFlyoutShowChanged = function (value) {
                var _this = this;
                if (value) {
                    if (this.contextMenuOptions && this.contextMenuOptions.length > 0) {
                        if (this.subMenuFlyout === null) {
                            this.subMenuFlyout = $("<div data-dyn-role='ContextMenu' data-dyn-bind=\"\"> </div>");
                            $(document.body).append(this.subMenuFlyout);
                            this.options = {
                                autoClose: false,
                                flyout: this.subMenuFlyout,
                                show: this.showMenu,
                            };
                            $dyn.util.flyout(this.options, false);
                            var dataContext = {
                                contextMenuOptions: this.contextMenuOptions,
                                contextMenuShow: this.showMenu,
                                Id: this.ContextMenuId,
                                parentSubMenuButton: this,
                            };
                            $dyn.dataBind(this.subMenuFlyout[0], dataContext);
                            var flyoutDataContext = $dyn.context(this.subMenuFlyout[0]);
                            flyoutDataContext.hasSubMenu = $dyn.observable(false);
                            flyoutDataContext.isHovered.valueChanged.subscribe(this.CloseContextMenu);
                            this.options.of = $(this.element);
                            if (!$dyn.util.isRTLMode()) {
                                this.options.my = "left top";
                                this.options.at = "right top";
                            }
                            else {
                                this.options.my = "right top";
                                this.options.at = "left top";
                            }
                            this.options.collision = "flip flip";
                            this.options.using = function (position) {
                                var menu = $(_this.subMenuFlyout);
                                var windowWidth = $(window).width();
                                // if the area was out of the window jQuery will return a negative value
                                // put it back on the screen
                                if (position.left < 0) {
                                    position.left = 0;
                                }
                                // check for the case that the contextmenu will run off the screen and shift it
                                if (position.left + $(menu).outerWidth() > windowWidth) {
                                    position.left = (windowWidth - $(menu).outerWidth());
                                }
                                // position the preview
                                $(menu).css({ top: position.top });
                                $(menu).css({ left: position.left });
                            };
                        }
                        this.showMenu(true);
                    }
                }
                else {
                    if (this.subMenuFlyout) {
                        this.CloseContextMenu();
                    }
                }
            };
            return SubMenuButton;
        }(controls.Button));
        controls.SubMenuButton = SubMenuButton;
        SubMenuButton.prototype.bindUpdate = false;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SubMenuButton.js.map
